
import { type ICatalogo, type IRespuestaApiLista } from '../../globales/interfaces';
import api from '../../utils/api';

// Modelo de Autenticación
class ModeloCausalEmergencia {
    
    constructor() { }

    public async obtenerListaCausalesEmergencia(): Promise<IRespuestaApiLista<ICatalogo>> {
        const { data } = await api.get(
           `/api/CausalEmergencias/Listar`, {
            headers: {
                "Content-Type": "application/json",

            },
        }); 
        return data;
    }

}

export default ModeloCausalEmergencia;
